export default "__VITE_ASSET__wK9J2791__"